import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=b5ad49b4&scoped=true&"
import script from "./Testimonials.vue?vue&type=script&lang=ts&"
export * from "./Testimonials.vue?vue&type=script&lang=ts&"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=b5ad49b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ad49b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b5ad49b4', component.options)
    } else {
      api.reload('b5ad49b4', component.options)
    }
    module.hot.accept("./Testimonials.vue?vue&type=template&id=b5ad49b4&scoped=true&", function () {
      api.rerender('b5ad49b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/company/Testimonials.vue"
export default component.exports